import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-light-svg-icons'

import { Box, ListItem, Text } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import { getPaidByTitleByKey, getPaymentMethodByKey } from '@functions/campaignContribution'

import type { CampaignContributionModel } from '@models/types'

import useCampaignContribution from '@hooks/useCampaignContribution'

interface CampaignContributionProps {
  campaignContribution: CampaignContributionModel,
}

const CampaignContribution = (props: CampaignContributionProps) => {
  const {
    campaignContribution,
    campaignContribution: {
      amount, paid_by, payment_method, payment_received, reference,
    },
  } = props

  const receivedDateString = digObject(campaignContribution, 'received.date')

  const { callbacks: { createOrEditCampaignContribution } } = useCampaignContribution(campaignContribution)

  return (
    <ListItem
      boxProps={{ borderBottom: '1px dashed', padding: 'large' }}
      onClick={() => createOrEditCampaignContribution()}
      showAngleIcon
    >
      <Box flexDirection="column" justifyContent="center">
        <Text fontSize="small">{reference}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {/*
           // @ts-expect-error TS2345 */}
          {getPaidByTitleByKey(paid_by)} via {getPaymentMethodByKey(payment_method)}
        </Text>
      </Box>

      <Box alignItems="flex-end" flexDirection="column" justifyContent="center" marginLeft="auto">
        {/*
         // @ts-expect-error TS2769 */}
        <Text fontSize="small">{formatMoney(amount)}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          {receivedDateString}
        </Text>
      </Box>

      <Box alignItems="center" color={payment_received ? 'green' : 'red'} marginLeft="medium" width="auto">
        <FontAwesomeIcon icon={payment_received ? faCheckCircle : faTimesCircle} />
      </Box>
    </ListItem>
  )
}

export default CampaignContribution
